__turbopack_context__.v({
  "callout": "_8Ci5wq_callout",
  "content": "_8Ci5wq_content",
  "iframeContainer": "_8Ci5wq_iframeContainer",
  "imageContainer": "_8Ci5wq_imageContainer",
  "imageGrid": "_8Ci5wq_imageGrid",
  "inlineImage": "_8Ci5wq_inlineImage",
  "link": "_8Ci5wq_link",
  "videoContainer": "_8Ci5wq_videoContainer",
});
